// Get Tracked Serials Use Case for Distribution

import {DistributionRepository} from '../repository/DistributionRepository';
import {AvailableSerial} from '../models/distribution.model';

export class GetTrackedSerialsUseCase {
  constructor (private distributionRepository: DistributionRepository) {}

  async execute (filters?: { productId?: string; locationId?: string; status?: string }): Promise<AvailableSerial[]> {
    try {
      const serials = await this.distributionRepository.getTrackedSerials(filters);

      // Business Logic: Sort by most recent first, group available serials at top
      const sortedSerials = serials.sort((a, b) => {
        // Available status first
        if (a.status === 'AVAILABLE' && b.status !== 'AVAILABLE') {return -1;}
        if (a.status !== 'AVAILABLE' && b.status === 'AVAILABLE') {return 1;}

        // Then by creation date (most recent first)
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
      });

      return sortedSerials;
    } catch (error) {
      throw error;
    }
  }
}
